module.exports = __webpack_public_path__ + "static/img/pos-img.b952816.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pos-img.png
// module id = sn+2
// module chunks = 0